"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var initialState = {
    isFullScreen: false,
    isChromecastDevicesVisible: false,
    restrictedMessage: null,
    lastCheckedContent: null,
    playerState: null,
};
var reducers = (_a = {},
    _a[constants_1.SET_IS_FULL_SCREEN] = function (state, action) { return (__assign(__assign({}, state), { isFullScreen: action.payload })); },
    _a[constants_1.SET_IS_CHROMECAST_DEVICES_VISIBLE] = function (state, action) { return (__assign(__assign({}, state), { isChromecastDevicesVisible: action.payload })); },
    _a[constants_1.SET_RESTRICTED_MESSAGE] = function (state, action) { return (__assign(__assign({}, state), { restrictedMessage: action.payload })); },
    _a[constants_1.SET_LAST_CHECKED_CONTENT] = function (state, action) { return (__assign(__assign({}, state), { lastCheckedContent: action.payload })); },
    _a[constants_1.SET_PLAYER_STATE] = function (state, action) { return (__assign(__assign({}, state), { playerState: action.payload })); },
    _a[constants_1.RESET_PLAYER_STATE] = function (state) { return (__assign(__assign({}, state), { playerState: null })); },
    _a);
exports.default = toolkit_1.createReducer(initialState, reducers);
//# sourceMappingURL=reducer.js.map